import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, ...props }) => (
    <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
        {...props}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ kicker, title, sub }) => (
    <div className="max-w-2xl">
        <Reveal>
            <span className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                {kicker}
            </span>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="mt-3 font-sans text-3xl font-extrabold tracking-tight text-brand-navy dark:text-white sm:text-4xl">
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className="mt-4 text-base leading-relaxed text-brand-navy/70 dark:text-white/65">
                    {sub}
                </p>
            </Reveal>
        )}
    </div>
);
